export default {
  navigation: [
    { name: 'Home', href: '/' },
    { name: 'Servizi', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'Chi siamo', href: '/about' },
    { name: 'Contatti', href: '/contact' }
  ],
  languages: [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' }
  ],
  contact: {
    phone: '+41 77 218 45 02',
    email: 'info@alpbuild.ch',
    address: 'Svizzera, cantoni di Vaud e Ginevra',
    whatsapp: '+41772184502',
    workingHours: 'Lun-Ven: 7:00-17:00'
  }
};